import Image from 'next/image';
import Link from 'next/link';

import Typography from '@components/Typography';

import NavigationCard from '../NavigationCard/NavigationCard';
import { CategoryCardInfo } from '../../components/category-promotion/CategoryPromotion';
import { RedDivider } from '../NavigationCard/NavigationCardStyles';
import {
  BottomInfo,
  BottomInfoContainer,
  Content,
  PriceContainer,
  TopInfo,
  TopInfoText,
} from './styled';

type Props = {
  info: CategoryCardInfo;
  onNavigate?: () => void;
};
const CategoryCard = ({ info, onNavigate }: Props) => (
  <Link
    href={info.link as string}
    onClick={onNavigate}
    data-testid='link'
    prefetch={false}
  >
    <Content>
      {info?.src ? (
        <Image
          fill
          style={{ objectFit: 'cover' }}
          src={info?.src}
          alt={info?.alt || 'setur'}
        />
      ) : null}
      {info.subText ? (
        <TopInfo>
          <RedDivider height={18} />
          <TopInfoText>{info.subText}</TopInfoText>
        </TopInfo>
      ) : null}
      <BottomInfoContainer>
        <BottomInfo>
          <Typography variant='Title4' color='NL0' weight='Bold'>
            {info?.title}
          </Typography>
          {info?.price ? (
            <PriceContainer>
              <NavigationCard
                info={{
                  price: info?.price,
                  subText: info.subText,
                  link: info.link,
                  name: info.title,
                }}
                onNavigate={onNavigate}
                styles={{
                  textColor: 'white',
                  desktopFontSize: 28,
                  mobileFontSize: 20,
                  containerDisplayFlex: true,
                }}
              />
            </PriceContainer>
          ) : null}
        </BottomInfo>
      </BottomInfoContainer>
    </Content>
  </Link>
);

export default CategoryCard;
